import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { globalVariables } from '../constants/globalVariables';
import { I18nService } from 'src/app/core/services/i18n.service';
@Injectable({
  providedIn: 'root'
})
export class LangService {

  public langData:any;


  constructor(public router:Router, public i18nService: I18nService,) {
    this.langData = globalVariables.currentLanguageData;
  }

  changeLang() {
    this.langData = globalVariables.currentLanguageData;
  }

//   changeLangToBangla(){
//  let language='bn'
//     let path = this.router.url;
//     path = path.substr(1, path.length);
//     console.log(this.router.url)
//     console.log(path)
//     let pathStr = path.split("/")[0];
//     console.log(pathStr)
//     this.i18nService.getLanguageData(`${pathStr}/${language}`).subscribe(
//       dataFromApi => {
//         globalVariables.currentLanguageData = dataFromApi;
//         console.log(dataFromApi);
//         this.changeLang();
//       },
//       err => { console.log(err); }
//     );

//   }



}
